<template xmlns="http://www.w3.org/1999/html">
    <div style="background: #F7F7F7;">
        <div class="info_page" v-cloak>
            <div class="info_tips">信息仅用于审批借款额度，资料将被加密保护</div>
            <div class="user_name">
                <van-field
                        v-model="userName"
                        label="真实姓名"
                        placeholder="请输入用户名"
                        :disabled="disabled"
                />

            </div>
            <div class="user_name">
                <van-field
                        v-model="idCard"
                        label="身份证号"
                        placeholder="请填写您本人的身份证号码"
                        :disabled="disabled"
                />
            </div>
            <div
                    v-show="needAuthentication"
                    class="suer_user"
                    :class="{'sure_can_click':userName && idCard}"
                    @click="authentBtn"
            >
                立即认证
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            // Head,
        },
        data() {
            return {
                disabled: false, //是否可编辑
                needAuthentication: true,
                productId: "",
                userName: "",
                idCard: "",
            }
        },
        created() {

        },
        mounted() {
            this.productId = this.$route.query.productId;
            this.util.title('实名信息');
        },
        computed: {
            userMoney() {
                console.log(this.userDate + "   " + this.productDetail.interestRateStart + "  " + this.defaultMoney)
                if (this.userDate && this.userDate && this.productDetail.interestRateStart) {
                    // (金额/期数)*(1+rate/100)
                    var money = ((this.defaultMoney / this.userDate) * (1 + this.productDetail.interestRateStart / 100)).toFixed(2);
                    console.log(money)
                    return money;
                }
                return ''
            }
        },
        methods: {
            authentBtn() {
                if (this.userName == "") {
                    this.util.toast({msg: "真实姓名不能为空"});
                    return;
                } else if (this.idCard == "") {
                    this.util.toast({msg: "身份证号不能为空"});
                    return;
                }
                console.log(this.userName + "   " + this.idCard)
                let param = {
                    realName: this.userName,
                    IDCard: this.idCard
                };
                this.$post("/app/api/v1/realname/authentication", param)
                    .then(res => {
                        if (res.code == 200) {
                            this.$router.push({
                                path: "/vip/new/assetsInfoYiXin",
                                query: {
                                    productId: this.productId,
                                    source: 1
                                },
                            });
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    }).catch(err => {
                })
            },
        }

    }
</script>
<style scoped>
    [v-cloak] {
        display: none;
    }

    .info_page {
        min-height: 100%;
        background: #F7F7F7;
        font-family: PingFangSC-Medium, PingFang SC;
    }

    .info_tips {
        width: 100%;
        height: 0.36rem;
        background: #e6ebff;
        color: #5983fc;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.36rem;
    }

    .user_name {
        padding: 0 0.1rem;
        background: #ffffff;
    }

    .suer_user {
        width: 92%;
        height: 0.5rem;
        margin-left: 4%;
        margin-top: 0.4rem;
        background: linear-gradient(
                133deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 0.25rem;
        opacity: 0.4;
        text-align: center;
        line-height: 0.5rem;
        color: #fff;
        font-size: 0.17rem;
        font-weight: 500;
    }

    .sure_can_click {
        opacity: 1;
    }

</style>
